module.exports = __webpack_public_path__ + "assets/audio/6f2eb51e7853dc18cef49835d37dbde5.wav";